import { Button } from '@monksflow/monks-ui';
import { SmileIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FormSectionV2, PersonaRepeaterRows } from '../../PersonaFormSectionsV2';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

// eslint-disable-next-line i18next/no-literal-string -- react-hook-form field-array name, not copy
const FIELD_ARRAY_NAME = 'gains';
// eslint-disable-next-line i18next/no-literal-string -- react-hook-form field path, not copy
const DESCRIPTION_FIELD = 'description';

export function GainsSectionV2() {
  const { t } = useTranslation('audiences');
  const { control, gainsArray } = useEditPersonaFormContext();

  return (
    <FormSectionV2
      icon={<SmileIcon className="size-5" />}
      title={t('audiences.gainsSection.gains')}
      headerAction={
        <Button variant="outline" size="sm" onClick={() => gainsArray.append({ description: '' })}>
          <PlusIcon className="size-4" />
          {t('audiences.gainsSection.addGain')}
        </Button>
      }
    >
      <PersonaRepeaterRows
        control={control}
        name={FIELD_ARRAY_NAME}
        fields={gainsArray.fields}
        onRemove={gainsArray.remove}
        columns={[
          {
            name: DESCRIPTION_FIELD,
            label: t('audiences.gainsSection.description'),
            required: isNestedFieldRequired('gains', 'description'),
          },
        ]}
      />
    </FormSectionV2>
  );
}

GainsSectionV2.displayName = 'GainsSectionV2';
